var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.571,
    height: 25.804,
    viewBox: "0 0 25.571 25.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-2103333",
    transform: "translate(-157.5 -87.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M261.777,100.053a6.277,6.277,0,1,0-6.277-6.277A6.25,6.25,0,0,0,261.777,100.053Zm0-10.229a3.952,3.952,0,1,1-3.952,3.952A3.919,3.919,0,0,1,261.777,89.825Z",
    transform: "translate(-91.491)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M172.843,304.5h-5.114A10.244,10.244,0,0,0,157.5,314.729a1.162,1.162,0,1,0,2.325,0,7.912,7.912,0,0,1,7.9-7.9h5.114a7.912,7.912,0,0,1,7.9,7.9,1.162,1.162,0,1,0,2.325,0A10.319,10.319,0,0,0,172.843,304.5Z",
    transform: "translate(0 -202.587)",
    fill: "#bec4de"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0f52cd907c7bfc2db5e03b9e966de44a.svg";
export { ForwardRef as ReactComponent };